<ng-template #dropPicTemplate let-item>
  <!--Thumbnail-->
  <img *ngIf="item?.imageVisible && (item?.dokPages === null || item?.dokPages <= 1)"
       alt="{{item.dokName}}"
        (click)="openImageEditor(item)"
        [tooltip]="'Bild bearbeiten'" flow="bottom"
        [src]="computeImageUrl(item)"
        class="pageimage"/>
  <img *ngIf="item?.imageVisible && item?.dokPages > 1 && item?.selectedPage"
       (click)="openImageEditor(item)"
       alt="{{item.dokName}}"
       [tooltip]="'Bild bearbeiten'" flow="bottom"
       [src]="computePageImageUrl(item)"
       class="pageimage"/>
  <div class="grid-auto-1"
      style="    position: absolute;
                  bottom: 0;
                  left: 0;">
    <i *ngIf="!isLoadingTab"
       class="search-action fas fa-comment-pen pic-comment"
       [tooltip]="'Bildunterschrift ändern'" flow="right"
       (click)="changePicComment(item)">
    </i>
    <span *ngIf="item?.comment && item.comment !== '' "
          style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;
          color: var(--c-neutral-800); background-color: var(--c-neutral-000);
    ">
      {{item.comment}}
    </span>
  </div>
</ng-template>
<ng-template #picboxPicTemplate let-item>
  <img  *ngIf="item?.imageVisible"
        alt="{{item.dokName}}"
        src="{{excRest.computeUrl('ImageThumbnail120',{dokID: item.dokID})}}"
       (click)="picbox.showAttachmentPreview(item.dokID);"
       class="tablepic"/>
</ng-template>
<div class="md3-surface content grid-1-auto">
  <!--Content-->
  <div *ngIf="!isLoadingInitEdit" [style.visibility]="!isLoadingTab ? 'visible' : 'hidden'" class="app-photodoc content grid-auto-1">
    <div class="pagesbox layout-auto-1 md3-card-on-surface content width-400" >
      <!--Header-->
      <div class="grid-1-auto photodoc-pages-header">
        <h4>Seiten</h4>
        <div style="padding-right: 8px">
          <i  *ngIf="!isLoadingTab"
              class="fal fa-file-plus app-drawer-icon" (click)="addPage()"
              [tooltip]="'Seite hinzufügen'" flow="left">

          </i>
        </div>
      </div>
      <!--Content links-->
      <div class="content stack-center" cdkDropList [cdkDropListData]="pages" id="pagesbox" [cdkDropListConnectedTo]="['pagesbox']"
           (cdkDropListDropped)="dropPage($event)">
        <!--erste Schleife, über Pages-->
        <ng-container *ngFor="let page of pages; index as i" >
          <div class="photodoc-page card" cdkDrag [cdkDragData]="page">
            <!--Page Side Functions-->
            <i *ngIf="!isLoadingTab"
               class="fas fa-fw fa-times-circle search-action" (click)="removePage(page)"
               [tooltip]="'Seite entfernen'" flow="left"></i>
            <app-exg-dropdown position="underleft">
              <ng-template #hostTemplate>
                <i *ngIf="!isLoadingTab"
                   class="fas fa-fw fa-ellipsis-v search-action"
                   [tooltip]="'Einstellungen'" flow="left"></i>
              </ng-template>
              <ng-template #contentTemplate let-popup>
                <div class="content">
                  <div (click)="changePageTemplate(page, 1);popup.close();" class="md-menu-item">1 Bild Template</div>
                  <div (click)="changePageTemplate(page, 2);popup.close();" class="md-menu-item">2 Bild Template</div>
                  <div (click)="changePageTemplate(page, 4);popup.close();" class="md-menu-item">4 Bild Template</div>
                  <div *ngIf="excSecurity.isFeatured('DEVELOPMENT')" (click)="changeHeaderOrFooter(true,i, page.header);popup.close();" class="md-menu-item">Kopfzeile bearbeiten</div>
                  <div *ngIf="excSecurity.isFeatured('DEVELOPMENT')" (click)="changeHeaderOrFooter(false, i, page.footer);popup.close();" class="md-menu-item">Fußzeile bearbeiten</div>
                </div>
              </ng-template>
            </app-exg-dropdown>
            <!--Page Content-->
            <div class="layout-auto-1-auto"  >
              <div class="photodoc-pageheader">{{page.header}}</div>
              <div class="photodoc-grid grid cols-2">
                <!--zweite Schleife, über die Droplisten der page-->
                <ng-container *ngFor="let position of ['top', 'left', 'right', 'bottom']">
                  <div class="photodoc-droplist"
                       [ngClass]="{'span-2': position === 'top' || position === 'bottom', 'half': page.layout === 2 && (position === 'top' || position === 'bottom')}"
                       *ngIf="(position === 'top' && [1, 2].includes(page.layout))
                           || (position === 'left' && [4].includes(page.layout))
                           || (position === 'right' && [4].includes(page.layout))
                           || (position === 'bottom' && [2].includes(page.layout))"
                       cdkDropList [cdkDropListData]="page[position]"
                       [id]="page.dropListID + '-' + position"
                       [cdkDropListConnectedTo]="connectedListsId"
                       (cdkDropListDropped)="dropPictureOnLeft($event, page)"
                       [cdkDropListEnterPredicate]="isPicDropAvailableWrapper(page, position)">
                    <!--Dropcounter pro Droplist auf Page-->
                    <div class="dropcounter">{{page[position].length}}/{{getBoxMaxPicCount(page, position)}}
                      <i class="fas fa-image"></i>
                      <ng-container *ngIf="page[position].length === getBoxMaxPicCount(page, position)">
                        <i class="fas fa-check"></i>
                      </ng-container>
                    </div>
                    <!--dritte Schleife, über die einzelnen Droplisten Bilder-->
                    <ng-container *ngFor="let item of page[position]">
                      <div class="image-container" cdkDrag [cdkDragData]="item">

                        <ng-template cdkDragPreview>
                          <img *ngIf="item?.imageVisible && (item?.dokPages === null || item?.dokPages <= 1)"
                               alt="{{item.dokName}}"
                               [src]="computeImageUrl(item)"
                               class="pageimage"/>

                          <img *ngIf="item?.imageVisible && item?.dokPages > 1 && item?.selectedPage"
                               alt="{{item.dokName}}"
                               [src]="computePageImageUrl(item)"
                               class="pageimage"/>
                        </ng-template>

                        <ng-container *ngTemplateOutlet="dropPicTemplate; context:{$implicit: item}"></ng-container>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
                <label class="pagecount">{{i + 1}}/{{pages.length}}
                </label>
            </div>
              <div class="photodoc-pagefooter">{{page.footer}}</div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="picbox layout-auto-1-auto md3-card-on-surface content">
      <!-- Search Header -->
      <exg-search-bar (Search)="picbox.search($event)"
                      [placeholder]="'Suche nach Dateiname oder Typ'"
                      class="span-layout">
        <ng-template #rightTemplate>
            <i *ngIf="!isLoadingTab"
               [tooltip]="'Aktualisieren'"
               [class.disabled]="picbox.state === 1"
               (click)="picbox.loadData()" class="search-action fal fa-sync"></i>
            <i *ngIf="!isLoadingTab"
               [tooltip]="picbox.hideOriginals ? 'Originale einblenden' : 'Originale ausblenden'"
               [class.disabled]="picbox.state === 1"
               [class.c-green]="picbox.hideOriginals"
               (click)="picbox.toggleShowAllMedia()" class="search-action fal fa-copy"></i>
        </ng-template>
      </exg-search-bar>
      <!--Content rechts-->
      <div class="picbox-list content">
        <div class="gallery-grid content" cdkDropList [cdkDropListData]="picbox.data"
             [cdkDropListConnectedTo]="connectedListsId" (cdkDropListDropped)="dropPictureOnRight($event)" id="piclist">
          <ng-container *ngFor="let row of picbox.data; let i = index">
            <div *ngIf="!row.dokDEL &&
            (i === 0 ||
             row.dok_enmIdent_DokTyp !== picbox.data[i - 1].dok_enmIdent_DokTyp)"
                 class="gallery-folder-header grid-1-auto app-space_075">
              <div> {{enumSvc.getEnumerationText('DokTyp', row.dok_enmIdent_DokTyp)}} </div>
              <div> ({{getPicboxFolderCount(row)}}) </div>
            </div>
            <div *ngIf="!row.dokDEL" cdkDrag class="gallery-item" [cdkDragData]="row">
              <div class="gallery-info">
              <span class="gallery-filename" [tooltip]="row.dokName + row.dokErw" flow="bottom">
                {{row.dokName}}{{row.dokErw}}
              </span>
                <span class="gallery-type">
                  Typ: {{getFileType(row)}}
                </span>
              <span *ngIf="row.dokPages > 0" class="gallery-pages">
                {{row.dokPages}} Seiten
              </span>
              </div>
              <div class="gallery-preview">
                <img src="{{excRest.computeUrl('ImageThumbnailBig',{dokID: row.dokID})}}"
                     (click)="picbox.showAttachmentPreview(row.dokID);"
                     class="gallery-image"/>
                <i *ngIf="row.dokIsEdited"
                   (click)="openImageEditor(row)"
                   [tooltip]="'Kopie bearbeiten'"
                   flow="bottom"
                   class="fal fa-copy gallery-edit-icon">
                </i>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <!-- Loading Content -->
  <div [style.visibility]="isLoadingTab ? 'visible' : 'hidden'" class="content" style="position: absolute; width: 100%">
    <div class="splash loading"><div class="spinner"><div></div><div></div><div></div><div></div></div></div>
  </div>
  <!--Sidebar-->
  <div [style.visibility]="!isLoadingTab ? 'visible' : 'hidden'" class="app-drawer md3-card-on-surface app-height-auto">

    <i *ngIf="!isLoadingTab" (click)="pressedSave()" [class.disabled]="!canSavePhotoDoc" [tooltip]="'Speichern'" flow="left" class="fal fa-save app-drawer-icon"></i>
    <i *ngIf="!isLoadingTab && !isNewPhotoDocMode" (click)="openPhotoDocDetails()" [tooltip]="'Details bearbeiten'" flow="left" class="fal fa-pencil-alt app-drawer-icon"></i>
    <i  *ngIf="!isLoadingTab"
        class="search-filter-seperator"></i>
    <i *ngIf="!isLoadingTab" (click)="downloadPDF()" [tooltip]="'Download'" flow="left" class="fal fa-download app-drawer-icon"></i>
    <i *ngIf="!isLoadingTab" (click)="previewPDF()" [tooltip]="'Vorschau'" flow="left" class="fal fa-eye app-drawer-icon"></i>
    <i  *ngIf="!isLoadingTab"
        class="search-filter-seperator"></i>
    <i *ngIf="!isLoadingTab"
       class="app-drawer-icon fas fa-layer-group"
       [class.c-green]="picbox.allPDFPagesMode" (click)="togglePDFPagesMode()"
       [tooltip]="picbox.allPDFPagesMode
         ? 'Mehrseitenmodus: Alle Seiten übernehmen'
         : 'Einzelseitenmodus: Seiten auswählen'"
       flow="left"></i>
    <i  *ngIf="!isLoadingTab"
        class="app-drawer-icon fal fa-upload" (click)="showAttachmentUploadModal()" [tooltip]="'Anlage hochladen'" flow="left"></i>
  </div>
</div>
